var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary"},[_c('div',{staticClass:"all-summary-grid"},[_c('store-summary',{staticClass:"store-sum"}),_c('driver-summary',{staticClass:"driver-sum"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }